import React from "react"
import Skeleton, { SkeletonProps } from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

export interface SkeletonLoaderProps extends SkeletonProps {
  lineCount?: number
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  lineCount,
  ...rest
}) => {
  return (
    <Skeleton
      count={lineCount}
      height={rest.height || "100%"}
      containerClassName="flex-1"
      {...rest}
    />
  )
}

export default SkeletonLoader
